import React, { createContext, useContext, useState, useEffect } from "react";
import { parseCookies, destroyCookie } from "nookies";
import { getAuth, signOut } from "firebase/auth";

interface AuthContextType {
  isAuthenticated: boolean;
  logout: () => void;
  login: () => void; 
}

const AuthContext = createContext<AuthContextType>({
  isAuthenticated: false,
  logout: () => {},
  login: () => {},
});

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const cookies = parseCookies();
    setIsAuthenticated(!!cookies["next-auth.session-token"]);
  }, []);

  const logout = async () => {
    destroyCookie(null, "next-auth.session-token");
     destroyCookie(null, "next-auth.session-token", {
          path: "/", 
        });
    setIsAuthenticated(false);
      const auth = getAuth();
  try {
    await signOut(auth);
  } catch (error) {
    console.error("Sign-out error:", error);
  }


    try {
      const response = await fetch('/api/guest-token', { method: 'POST' });
      if (!response.ok) throw new Error('Failed to generate guest token');
    
    } catch (error) {
      console.error('Error generating guest token:', error);
    }
  };

  const login = () => {
    destroyCookie(null, 'next-auth.guest-token');

    setIsAuthenticated(true);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, logout, login }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
